var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1605 0.728004C23.0258 0.797337 20.3725 3.40934 15.9738 7.804L9.00048 14.772L6.02715 11.8053C4.06049 9.84134 2.97782 8.8 2.82982 8.72534C2.36049 8.49067 1.85249 8.612 1.39915 9.06534C0.937819 9.52667 0.817819 10.0133 1.05249 10.484C1.21915 10.8173 8.18315 17.7813 8.51648 17.948C8.82448 18.1013 9.17648 18.1013 9.48448 17.948C9.82048 17.78 24.7805 2.82 24.9485 2.484C25.1818 2.01334 25.0632 1.52667 24.6018 1.06534C24.1485 0.612003 23.6245 0.489337 23.1605 0.728004Z",
    fill: "#64FF86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.svg";
export { ForwardRef as ReactComponent };